





























































import { computed, defineComponent, ref } from "@vue/composition-api";
import { handleError } from "@/lib/error-handling";
import { getBase64 } from "@/lib/get-base64";

export interface HTMLFileInputEvent extends HTMLInputElement {
  target: {
    files?: File[];
  };
}

export default defineComponent({
  props: {
    color: {
      default: "primary"
    },
    disabled: Boolean,
    text: {
      default: "Select Image"
    },
    showFileName: {
      default: true
    },
    loading: {
      default: false
    },
    icon: {
      default: "photo"
    },
    fileOnly: {
      default: false
    },
    accept: {
      default: "image/jpeg, image/png"
    }
  },
  setup(_, { emit }) {
    const input = ref<null | HTMLInputElement>(null);
    const file = computed(() => {
      return (
        input && input.value?.value && input.value.files && input.value.files[0]
      );
    });
    const fileBase64 = ref<string | null>(null);
    const base64Loading = ref(false);

    const reset = () => {
      fileBase64.value = null;
      base64Loading.value = false;
      if (input.value) input.value.value = "";
      emit("reset");
    };

    const fileChange = async (event: HTMLFileInputEvent) => {
      const file = event.target.files && event.target.files[0];
      if (file) {
        emit("fileChange", file);
        base64Loading.value = true;
        try {
          fileBase64.value = (await getBase64(file)) as string;
          emit("base64Change", fileBase64.value);
        } catch (error) {
          handleError(error, "Couldn't get image", 4000);
        } finally {
          base64Loading.value = false;
        }
      } else {
        emit("base64Change", null);
        emit("fileChange", null);
      }
    };

    return {
      input,
      file,
      reset,
      fileChange
    };
  }
});
